export default "__VITE_ASSET__b2df972c__"